module.exports = __webpack_public_path__ + "static/img/input_error.dd5ebc1.svg";


//////////////////
// WEBPACK FOOTER
// ./yotta-vue-components/vision/assets/input_error.svg
// module id = 3N2D
// module chunks = 1